module.exports = __webpack_public_path__ + "img/del_hint.78011685.png";